import { SubscriptionLineItemV2 } from 'state/internal/getSubscriptionDetails/types';

export function formatProductsListV2(products: SubscriptionLineItemV2[], qtyTranslation: string) {
  return products
    .map(({ product: { name }, quantity }) =>
      quantity > 1 ? `${name} ${qtyTranslation} ${quantity}` : name
    )
    .join(', ');
}
